import {useGameServerConnection, useLoadingState, useScene} from '@glark-newco/game-library';
import {sound} from '@pixi/sound';
import {useEffect, useMemo} from 'react';
import {CracklingFireSoundEffect} from './components/CracklingFireSoundEffect';
import {Lobby} from './scenes/Lobby';
import {Play} from './scenes/Play';
import {PreLoader} from './scenes/PreLoader';
import {Register} from './scenes/Register';
import {Review} from './scenes/Review';

export function SignlinesCanvas() {
    const [loadingState] = useLoadingState();
    const sceneName = useScene();
    const {connectionReady} = useGameServerConnection();

    const scene = useMemo(()=>{
        if (loadingState === 'PRELOAD')
            return <PreLoader/>;
        else if (!connectionReady)
            return <Register/>;
        else if (sceneName === 'LOBBY')
            return <Lobby/>;
        else if (sceneName === 'PLAY')
            return <Play/>;
        else
            return <Review/>;
    }, [loadingState, sceneName, connectionReady]);

    useEffect(() => {
        sound.disableAutoPause = true;
    }, []);

    return (
        <>
            <CracklingFireSoundEffect scene={sceneName} loadingState={loadingState}/>
            {scene}
        </>
    );
}
